<template>
    <div class="os-tabs-w">
        <div class="os-tabs-controls">
            <ul class="nav nav-tabs upper">
                <li class="nav-item" v-for="tab in tabOptions" ><a class="nav-link" @click="changeTab(tab)" :class="{ 'active': selectedTab == tab }">{{tab}}</a></li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
  props: ['tabOptions', 'selectedTab'],
  methods: {
    changeTab: function (tab) {
      this.$emit('sessionTabInterface', tab)
    }
  }
}
</script>
